export default {
  resolve(grade) {
    switch (grade) {
      case 'Pre-Kindergarten':
      case '4 - 5':
        return '-1'
      case 'Kindergarten':
      case '5 - 6':
        return 'K'
      case 'Grade 1':
      case '6 - 7':
        return '1'
      case 'Grade 2':
      case '7 - 8':
        return '2'
      case 'Grade 3':
      case '8 - 9':
        return '3'
      case 'Grade 4':
      case '9 - 10':
        return '4'
      case 'Grade 5':
      case '10 - 11':
        return '5'
      case 'Grade 6':
      case '11 - 12':
        return '6'
      case 'Grade 7':
      case '12 - 13':
        return '7'
      case 'Grade 8':
      case '13 - 14':
        return '8'
      case 'Grade 9':
      case '14 - 15':
        return '9'
      case 'Grade 10':
      case '15 - 16':
        return '10'
      case 'Grade 11':
      case '16 - 17':
        return '11'
      case 'Grade 12':
      case '17 - 18':
        return '12'
      case 'Post-Secondary':
      case '18+':
        return '13'
      default:
        throw Error
    }
  }
}
